import React from 'react';
import { FormControl, Switch, FormControlLabel } from '~/lib/bn-material-ui';

export function BnToggleSwitch(props) {
  const { label, formControlClassName, ...defaultProps } = props;
  return (
    <FormControl className={formControlClassName}>
      <FormControlLabel control={
        <Switch
          {...defaultProps}
        />
      } label={label} />
    </FormControl>
  );
}
